// extracted by mini-css-extract-plugin
export default {"templatesTitleAndAddButton":"templates-header_templatesTitleAndAddButton__cZzAD","addButton":"templates-header_addButton__zDmuz"};